import css from 'styled-jsx/css';

export const ProductTopSpecificationsStyle = css`
  /* Element: Container */
  .product-top-specifications__container {
    padding: 0;
  }

  /* Element: Title */
  .product-top-specifications__title {
    display: none;
  }

  /* Element: List container */
  .product-top-specifications__list {
    margin: 0;
  }

  /* Element: Items list */
  .product-top-specifications__items {
    list-style: none;
    margin: 0;
    padding: 0;
    font-size: 14px;
    line-height: 1.5;
    color: #333;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0 16px;

    @media (max-width: 767px) {
      grid-template-columns: 1fr;
      gap: 0;
    }
  }

  /* Element: Individual item */
  .product-top-specifications__item {
    position: relative;
    padding-left: 16px;
    margin-bottom: 8px;
    line-height: 1.5;
  }

  .product-top-specifications__item::before {
    position: absolute;
    content: '•';
    left: 0;
    top: 0;
    color: #333;
    font-size: 14px;
    font-weight: bold;
    line-height: 1.5;
  }

  /* Element: Item name (bold part) - No debe cortarse */
  .product-top-specifications__item-name {
    font-weight: 600;
    color: #333;
    display: inline;
    margin-right: 4px;
  }

  /* Element: Item value - Puede ir a la siguiente línea manteniendo indentación */
  .product-top-specifications__item-value {
    color: #333;
    font-weight: 400;
    word-break: break-word;
    display: inline;
  }

  /* Element: Actions container */
  .product-top-specifications__actions {
    margin: 8px 0 0 16px;
  }

  .product-top-specifications__actions :global(.specifications-action) {
    font-weight: 700;
    font-style: Bold;
    color: #333;
  }

  /* Element: Mobile actions container */
  .product-top-specifications__mobile-actions {
    display: flex;
    flex-direction: column;
  }

  /* Element: View more button */
  .product-top-specifications__view-more-button {
    background: none;
    border: none;
    color: #007bff;
    font-family: inherit;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 1.4;
    text-decoration: underline;
    padding: 0;
    cursor: pointer;
    align-self: flex-start;
    transition: color 0.2s ease-in-out;
  }

  .product-top-specifications__view-more-button:hover {
    color: #0056b3;
    text-decoration: underline;
  }

  .product-top-specifications__view-more-button:focus {
    outline: 2px solid #007bff;
    outline-offset: 2px;
    border-radius: 2px;
  }

  /* Element: Drawer content */
  .product-top-specifications__drawer-content {
    padding: 16px;
  }

  /* Element: Divider */
  .product-top-specifications__divider {
    display: none;
  }
`;
